import { useEffect, useState } from "react";

/** A live HH:MM clock for the shell strip's footer (refreshes every 20s). */
export function useClock(): string {
  const read = () => {
    const d = new Date();
    return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  };
  const [time, setTime] = useState(read);
  useEffect(() => {
    const id = setInterval(() => setTime(read()), 20_000);
    return () => clearInterval(id);
  }, []);
  return time;
}
